import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { format } from '../lib/money';
import PurchasePaymentsScheduleLinkContainer from '../containers/purchase-payments-schedule-link.container';
import Purchase from '../lib/purchase';

class TotalCostAmount extends Component {
  getPriceRange() {
    return this.props.currentCostRange.map(cost => format(cost.amount)).join(' - ');
  }

  isTotalCostType() {
    return Purchase.isTotal(this.props.costType);
  }

  render() {
    let labelCopy = (
      <FormattedMessage
        id="totalCostAmount.title.perPerson"
        defaultMessage="Cost per person"
      />
    );

    if (this.isTotalCostType()) {
      labelCopy = (
        <FormattedMessage
          id="totalCostAmount.title.total"
          defaultMessage="Total cost"
        />
      );
    }

    return (
      <div className="total-cost-amount">
        <span className="small-print label">
          <i className="fa fa-tag mr-1" aria-hidden="true" />
          {labelCopy}
        </span>
        <br />
        <span className="amount">{this.getPriceRange()}</span>
        <br />
        <PurchasePaymentsScheduleLinkContainer
          constraints={this.props.constraints}
          namespace={this.props.namespace}
        />
      </div>
    );
  }
}

TotalCostAmount.defaultProps = {
  currentCostRange: [],
  costType: 'total',
};

export default TotalCostAmount;



// WEBPACK FOOTER //
// ./src/desktop/components/total-cost-amount.js